import { render, staticRenderFns } from "./prepStation.vue?vue&type=template&id=5d24bd80&scoped=true&lang=pug"
import script from "./prepStation.vue?vue&type=script&lang=js"
export * from "./prepStation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d24bd80",
  null
  
)

export default component.exports